import * as React from 'react'

export const AlignCenterIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} {...props}>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9609 5.83398C18.9609 6.17916 18.6811 6.45898 18.3359 6.45898L1.66927 6.45898C1.32409 6.45898 1.04427 6.17916 1.04427 5.83398C1.04427 5.48881 1.32409 5.20898 1.66927 5.20898L18.3359 5.20898C18.6811 5.20898 18.9609 5.48881 18.9609 5.83398Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4609 10C16.4609 10.3452 16.1811 10.625 15.8359 10.625L4.16927 10.625C3.82409 10.625 3.54427 10.3452 3.54427 10C3.54427 9.65482 3.82409 9.375 4.16927 9.375L15.8359 9.375C16.1811 9.375 16.4609 9.65482 16.4609 10Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9609 14.166C13.9609 14.5112 13.6811 14.791 13.3359 14.791L6.66927 14.791C6.32409 14.791 6.04427 14.5112 6.04427 14.166C6.04427 13.8208 6.32409 13.541 6.66927 13.541H13.3359C13.6811 13.541 13.9609 13.8208 13.9609 14.166Z" fill="currentColor"/>
</svg>
    )
  },
)

AlignCenterIcon.displayName = 'AlignCenterIcon'
